import { render } from "./offline.vue?vue&type=template&id=38e3fac4&scoped=true"
import script from "./offline.vue?vue&type=script&lang=js"
export * from "./offline.vue?vue&type=script&lang=js"

import "./offline.vue?vue&type=style&index=0&id=38e3fac4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e3fac4"]])

export default __exports__